import { createContext, useContext, useState } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("te_lang") || "it");
  const setLang = (l) => {
    localStorage.setItem("te_lang", l);
    setLangState(l);
    document.documentElement.lang = l;
  };
  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
